import React from 'react'

import classNames from 'classnames'

import Score from '@models/Score'
import {
  formatPublishedStatus,
  isArchived,
  isFinalized,
  isPublished,
  isPublishedScore,
} from '@models/util/score.util'

interface Props {
  score: Score
  className?: string
}

const PublishedScoreStatus: React.FC<Props> = ({ score, className }: Props) => {
  if (!isPublishedScore(score)) {
    return null
  }

  return (
    <div className={className}>
      <span
        className={classNames('text-white font-semibold py-0.5 px-2 rounded text-sm', {
          'bg-[#FF0000]': isFinalized(score),
          'bg-[#FFA31A]': isArchived(score),
          'bg-[#009900]': isPublished(score),
        })}>
        {formatPublishedStatus(score)}
      </span>
    </div>
  )
}

export default PublishedScoreStatus
